import { ComponentData, TabData } from '@ddt-web/data-service';
import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';


dayjs.extend(customParseFormat);
export class ModelPortfolioUtil {

	/**
	 * Checks is specific research models are part of the analysis as:
	 * - analysed research model (both on its own or in compare)
	 * - analysed blend with model as child (at level 1 or 2)
	 * - if shouldIncludeEngagementCheck is true, analysed engagement with model child
	 * 
	 * @param secResearchModels 
	 * @param data 
	 * @param shouldIncludeEngagementCheck 
	 * @returns true if provided research models are part of the analysis
	 */
	public static isResearchModelAnalysed(secResearchModels: string[], data: ComponentData, shouldIncludeEngagementCheck: boolean = false): boolean {
		if (data?.success && secResearchModels?.length) {
			return this.isIndividualResearchModelAnalysed(secResearchModels, data)
				|| this.isResearchModelChildAnalysed(secResearchModels, data)
				|| this.isResearchModelEngagementAnalysed(secResearchModels, data, shouldIncludeEngagementCheck);
		}

		return false;
	}

	public static isModelRebalanced(rebalanceTabData: TabData): boolean {
		const rebalanceCells = rebalanceTabData?.tableData?.[0]?.cells?.[0];
		if (rebalanceCells) {
			const previousRebalanceDate = rebalanceCells.find(cell => cell.config.id === 'previousRebalanceDate')?.formattedValue;
			const currentRebalanceDate = rebalanceCells.find(cell => cell.config.id === 'currentRebalanceDate')?.formattedValue;

			return Boolean(previousRebalanceDate !== currentRebalanceDate);
		}

		return false;
	}

	private static isIndividualResearchModelAnalysed(secResearchModels: string[], data: ComponentData): boolean {
		const idIndex = data.portfolioData?.[0]?.findIndex(portfolio => portfolio.config.id === 'id');
		return data.portfolioData.some(portfolio => secResearchModels.includes(portfolio[idIndex]?.rawValue as string));
	}

	private static isResearchModelChildAnalysed(secResearchModels: string[], data: ComponentData): boolean {
		let isResearchModelChildAnalysed = false;

		data.getTabById('portfolio.children')?.tableData?.forEach(tableData => {
			const hasModelAsChild = tableData.cells?.[0]?.some(child => secResearchModels.includes(child.rawValue as string));
			if (hasModelAsChild) {
				isResearchModelChildAnalysed = true;
			}
		});

		return isResearchModelChildAnalysed;
	}

	private static isResearchModelEngagementAnalysed(secResearchModels: string[], data: ComponentData, shouldIncludeEngagementCheck: boolean): boolean {
		if (shouldIncludeEngagementCheck) {
			const portKeyIndex = data.portfolioData?.[0]?.findIndex(portfolio => portfolio.config.id === 'portKey');
			return data.portfolioData.some(portfolio => secResearchModels.includes(portfolio[portKeyIndex]?.rawValue as string));
		}

		return false;
	}
}
